import { useState, useEffect } from "react";
import "./LiveUpdateIndicator.css";

function LiveUpdateIndicator({ lastUpdate }) {
    const [secondsAgo, setSecondsAgo] = useState(0);

    useEffect(() => {
        if (!lastUpdate) return;

        const tick = () => setSecondsAgo(Math.floor((Date.now() - lastUpdate) / 1000));
        tick();

        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [lastUpdate]);

    if (!lastUpdate) return null;

    return (
        <span className="live-update-indicator" title="The Reviewing column refreshes automatically">
            <i className="fas fa-circle live-update-indicator_dot"></i>
            Live data updated {secondsAgo}s ago
        </span>
    );
}

export default LiveUpdateIndicator;
